module.exports = __webpack_public_path__ + "img/Tc.f7901f74.png";